import React from 'react';
import Link from '@atlaskit/link';
import { useLocation } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
};

export const LinkToSignupPage = ({ children, onClick }: Props) => {
  const { search } = useLocation();

  return (
    <Link href={'/signup' + search} id="signup" onClick={onClick}>
      {children}
    </Link>
  );
};
